<div class="section-zuli">

  <div class="container">
    <div class="row container-img-canais">
      <div class="col-lg-2 text-center">
        <h2 class="title-mb">Ainda precisa de ajuda?</h2>
        <img src="/assets/img/avatar-zuli.png" alt="" />
      </div>
      <div class="canais-atendimentos col-lg-9">
        <h2 class="title-desk">Ainda precisa de ajuda?</h2>
        <div class="mt-5 row">
          <div class="card-canais col-12 col-md mt-0">
            <span class="text-orange">Fale com a Zuli pelo WhatsApp</span>
            <div class="container-number d-flex align-items-center">
              <img src="/assets/img/icons/wpp-negativo.svg" alt="" />
              <a
                class="number"
                href="https://api.whatsapp.com/send/?phone=5511941473336"
                target="_blank"
                >(11) 94147-3336</a
              >
            </div>
            <div>
              <div>
                <img src="/assets/img/icons/despertador.svg" alt="" />
                <span class="text-base"
                  ><strong>Horário de atendimento:</strong></span
                >
              </div>
              <p class="text-base mt-2">
                Segunda-feira a sábado,<br />
                das 8h às 20h<br />
                (exceto feriados)
              </p>
            </div>
          </div>
          <div class="card-canais col-12 col-md">
            <span class="text-orange">Fale com a nossa Central Telefônica</span>
            <div class="container-number">
              <div>
                <a class="number" href="tel:+5530035365">3003 5365</a>
                <p class="text-base mt-2">Capital e Grande São Paulo</p>
              </div>
              <div class="mt-3">
                <a class="number" href="tel:+5508007295365">0800 729 5365</a>
                <p class="text-base mt-2">Demais localidades</p>
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center">
                <img src="/assets/img/icons/despertador.svg" alt="" />
                <span class="text-base"
                  ><strong>Horário de atendimento:</strong></span
                >
              </div>
              <p class="text-base mt-2">
                Segunda-feira a domingo,<br />
                das 8h às 22h<br />
                (exceto feriados)
              </p>
            </div>
          </div>
          <div *ngIf="!hiddenCta" class="card-canais app-caixa col-12 col-md">
            <span class="text-orange">Cliente App CAIXA Tem</span>
            <p class="text-base">
              Tire suas dúvidas direto no chatbot do aplicativo.
            </p>
            <div class="content-link">
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=br.gov.caixa.tem&hl=pt_BR&pli=1"
                >Baixe aqui</a
              ><svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1694 7.96006C14.4698 7.24615 13.7509 6.55468 13.0754 5.81293C11.9605 4.58986 10.8746 3.33537 9.77574 2.09523C9.51951 1.80698 9.4159 1.47379 9.52594 1.07687C9.62715 0.713185 9.86008 0.509375 10.1854 0.439331C10.4842 0.375573 10.7332 0.49319 10.9444 0.732057C12.8095 2.84594 14.6754 4.95802 16.5421 7.071C16.9269 7.50653 17.3165 7.9358 17.7004 8.37222C18.1093 8.83739 18.0948 9.42287 17.6867 9.86738C16.3678 11.3042 15.0538 12.7464 13.7389 14.1885C12.8151 15.2024 11.8946 16.2198 10.9693 17.2319C10.5653 17.6737 10.0882 17.6907 9.72836 17.292C9.38136 16.9077 9.3974 16.3411 9.77813 15.8983C11.4705 13.9299 13.1654 11.9642 14.861 9.9994C14.869 10.003 14.7172 10.0632 14.5839 10.0632C10.0713 10.0596 5.55959 10.0605 1.04704 10.0596C0.875147 10.0596 0.703226 10.0748 0.534547 9.99761C0.15221 9.8225 -0.0485808 9.43455 0.0100551 8.95592C0.0598554 8.54643 0.349806 8.23575 0.736963 8.18995C0.882348 8.17289 1.03014 8.17736 1.17713 8.17736C5.64952 8.17736 10.1211 8.17736 14.5935 8.17736H15.0216C15.0706 8.10552 15.1196 8.03369 15.1686 7.96185L15.1694 7.96006Z"
                  fill="#EE8236"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
